import { useQuery } from '@apollo/client'
import {
  GroupWithMembers,
  GroupWithMembersVariables,
  SortDirectionEnum,
  UsersFilterInput,
} from '../../types'
import { GROUP_WITH_MEMBERS } from './operations'
import { SortByType } from '../../constants'

type Sorter = {
  sortBy?: string
  direction?: SortDirectionEnum
}

interface Props {
  groupId: string
  membersPage?: number
  pageLength?: number
  filterData?: UsersFilterInput
  membersSorter?: Sorter
}

const PAGE_LENGTH = 10

export const useGroupWithMembersData = ({
  groupId,
  membersPage,
  pageLength = PAGE_LENGTH,
  filterData,
  membersSorter,
}: Props) => {
  const groupWithMembersQuery = useQuery<GroupWithMembers, GroupWithMembersVariables>(
    GROUP_WITH_MEMBERS,
    {
      fetchPolicy: 'network-only',
      variables: {
        id: groupId,
        pagination: {
          from: Number(membersPage || 1) * pageLength - pageLength,
          length: pageLength,
          sortBy: membersSorter?.sortBy ?? SortByType.LAST_NAME,
          direction: membersSorter?.direction ?? SortDirectionEnum.ASC,
        },
        filterData,
      },
    }
  )

  return groupWithMembersQuery
}
